<template>
  <b-card>
    <portal-documentos-list
      ref="portalDocumentosList"
      :botoes-opcoes="botoesOption"
      :visualizacao-opcoes="visualizacao"
      :filtros="filtros"
      :filtros-rapidos="filtrosRapidos"
      :tem-filtro-extra="true"
      :tem-filtro-rapido="false"
      :show-botao-custom="true"
    >
      <template slot="show-botao-custom">
        <div class="d-flex align-items-center" style="gap: 10px;">
          <filtro-custom
            ref="filtroCustomModal"
            :api="apiPortal"
            :filtros-default-docs="filtrosDefaultDocs"
            @aplicarFiltro="aplicarFiltroCustom"
          />

          <b-dropdown
            variant="outline-primary"
            size="sm"
            style="white-space: nowrap;"
            toggle-class="d-inline-flex align-items-center"
            right
          >
            <template #button-content>
              <feather-icon
                icon="SendIcon"
                size="15"
                style="margin-right: 5px;"
              />
              Enviar por e-mail
            </template>
            <b-dropdown-item
              v-for="opcao in opcoesDestinatario"
              :key="opcao.value"
              @click="enviarEmailLoteGeral(opcao.value)"
            >
              {{ opcao.label }}
            </b-dropdown-item>
          </b-dropdown>

          <b-dropdown
            variant="outline-primary"
            size="sm"
            style="white-space: nowrap;"
            toggle-class="d-inline-flex align-items-center"
            v-b-tooltip.hover
            title="Baixar documentos"
            right
          >
            <template #button-content>
              <feather-icon
                icon="DownloadIcon"
                size="15"
                style="margin-right: 5px;"
              />
              Baixar documentos
            </template>
            <b-dropdown-item
              v-for="(opcao, index) in opcoesBaixaEmLote"
              :key="index"
              @click="tipoDownload = opcao; baixaEmLoteGeral()"
            >
              {{ opcao.nome || opcao }}
            </b-dropdown-item>
          </b-dropdown>
        </div>
      </template>
      <template
        slot="custom"
        slot-scope="{ props} "
      >
        <b-badge
          v-if="props.column.field === 'rfbPgfn' ||
            props.column.field === 'situacaoFiscal' ||
            props.column.field === 'fgts' ||
            props.column.field === 'trabalhista' ||
            props.column.field === 'estadual' ||
            props.column.field === 'municipal'"
          :variant="getColorTag(props.row[props.column.field])"
          @click="openModalVisualizacaoArquivo(props.row, props.column.field)"
        >
          <span v-html="getDescricao(props.row[props.column.field])" />
        </b-badge>
      </template>
      <template slot="filtro-extra">
        <b-row>
          <b-col cols="12">
            <v-select
              :ref="`SelectFiltroDocs`"
              v-model="filtroString"
              v-b-tooltip.hover
              :options="filtrosRapidosDocs"
              :clearable="true"
              multiple
              deselect-from-dropdown
              :disabled="filtroCustom != null"
              placeholder="Tipos de documentos"
              @input="mudarDocSelecionado($event)"
            />
          </b-col>
        </b-row>
      </template>
      <template
        slot="acoes"
        slot-scope="{ props} "
      >
        <acoes
          :ref="`acoes${props.row.id}`"
          :grid-props="props"
          :api="apiPortal"
          :docs="resolverFiltroParaEnviar()"
          @baixa-em-lote="baixaEmLoteLinha"
          @enviar-email="enviarEmailLinha($event.linha, $event.email)"
        />
      </template>
    </portal-documentos-list>
    <loading
      :show-cancel-button="false"
      :is-loading="isLoading"
      :descricao="'Enviando'"
    />
    <empresas-sem-email
      ref="empresaSemEmailList"
      v-model="empresasEmail"
      @salvar-email="salvarEmail($event)"
    />
  </b-card>
</template>

<style lang="scss">
.col-valores{
  white-space: nowrap;
}

[dir] #baixaPortalSelect {
  /* empty */
}
</style>

<script>

import vSelect from 'vue-select'
import api from './shared/services/api'
import '@core/scss/vue/libs/vue-select.scss'

export default {
  name: 'PortalDocumentosView',
  components: {
    vSelect,
    PortalDocumentosList: () => import('@pilar/components/visualizacao-base/VisualizacaoBase.vue'),
    Acoes: () => import('./shared/components/acoes/Acoes.vue'),
    FiltroCustom: () => import('@pilar/components/filtro-custom/FiltroCustom.vue'),
    Loading: () => import('@pilar/components/loading/Loading.vue'),
    EmpresasSemEmail: () => import('./shared/components/empresas-sem-email/EmpresasSemEmail.vue'),
  },
  data() {
    return {
      apiPortal: api,
      botoesOption: null,
      linha: null,
      visualizacao: {
        placeholderBusca: 'Buscar por: CNPJ/CPF, Razão social',
        acaoClass: 'col-td-acao-2',
        disabledCheckbox: false,
        colunas: [
          { label: 'Razão social', field: 'razaoSocial', tdClass: 'tamanho-col-razaoSocial-portalDocumentos' },
          { label: 'CNPJ/CPF', field: 'cadastroFederal', tdClass: 'tamanho-col-cadastroFederal-portalDocumentos col-valores' },
          {
            label: 'Situação Fiscal',
            field: 'situacaoFiscal',
            tdClass: 'text-center',
            type: 'custom',
            visible: false,
          },
          {
            label: 'RFB/PGFN',
            field: 'rfbPgfn',
            tdClass: 'text-center',
            type: 'custom',
            visible: false,
          },
          {
            label: 'FGTS',
            field: 'fgts',
            tdClass: 'text-center',
            type: 'custom',
            visible: false,
          },
          {
            label: 'Trabalhista',
            field: 'trabalhista',
            tdClass: 'text-center',
            type: 'custom',
            visible: false,
          },
          // {
          //   label: 'MTE',
          //   field: 'mte',
          //   tdClass: 'text-center',
          //   type: 'custom',
          //   visible: false,
          // },
          {
            label: 'Estadual',
            field: 'estadual',
            tdClass: 'text-center',
            type: 'custom',
            visible: false,
          },
          {
            label: 'Municipal',
            field: 'municipal',
            tdClass: 'text-center',
            type: 'custom',
            visible: false,
          },
        ],
      },
      filtros: [{ colunas: ['CadastroFederalSemMascara', 'CadastroFederal', 'RazaoSocial'], valor: null }],
      // filtrosDefaultDocs: ['Todos', 'Situação Fiscal', 'CND RFB/PGFN', 'CND FGTS', 'CND Trabalhista', 'CND MTE', 'CND Estadual', 'CND Municipal'],
      filtrosDefaultDocs: [],
      filtrosRapidosDocs: [],
      filtrosRapidos: [],
      filtroString: [],
      filtroCustom: null,
      criando: true,
      aplicando: false,
      filtroAtual: {},
      tipoDownload: null,
      opcoesBaixaEmLote: ['Arquivo Único', 'Por Empresa', 'Tipo de documento', 'Empresa e Tipo de documento'],
      isLoading: false,
      arrayColunas: ['situacaofiscal', 'rfbpgfn', 'fgts', 'trabalhista', 'estadual', 'municipal'],
      empresasEmail: [],
      opcoesDestinatario: [
        { value: 'principal', label: 'Apenas e-mail principal' },
        { value: 'adicional', label: 'Apenas e-mail adicional' },
        { value: 'ambos', label: 'Ambos os e-mails' },
      ],
    }
  },
  created() {
    this.montarColunasPermitidas()
    this.visualizacao.evento = this.carregar
    this.visualizacao.allpaged = this.allPaged
    this.tipoParcelamento = this.$route.meta.tipo
    this.filtrosRapidosDocs = this.filtrosDefaultDocs
    // this.carregarFiltro()
  },
  methods: {
    montarColunasPermitidas() {
      const userData = JSON.parse(localStorage.getItem('userData'))
      const acessos = userData.ability
      this.visualizacao.colunas.forEach(col => {
        const coluna = col.field.toLowerCase()
        if (!(coluna === 'razaosocial' || coluna === 'cadastrofederal')
        && !(coluna === 'situacaofiscal' && acessos.some(o => o.subject === 'situacaofiscal_federal'))
        && !(coluna === 'fgts' && acessos.some(o => o.subject === 'cnd_fgts'))
        && !(coluna === 'rfbpgfn' && acessos.some(o => o.subject === 'cnd_federal'))
        && !(coluna === 'trabalhista' && acessos.some(o => o.subject === 'cnd_trabalhista'))
        && !(coluna === 'estadual' && acessos.some(o => o.subject === 'cnd_estadual'))
        && !(coluna === 'municipal' && acessos.some(o => o.subject === 'cnd_municipal'))) {
          this.visualizacao.colunas = this.visualizacao.colunas.filter(obj => obj.field.toLowerCase() !== coluna)
        }
      })
      this.montarFiltrosDeDocumentos()
    },
    montarFiltrosDeDocumentos() {
      this.visualizacao.colunas.forEach(col => {
        const coluna = col.field.toLowerCase()
        if (coluna === 'situacaofiscal') {
          this.filtrosDefaultDocs.push('Situação Fiscal')
        } else if (coluna === 'rfbpgfn') {
          this.filtrosDefaultDocs.push('CND RFB/PGFN')
        } else if (coluna === 'fgts') {
          this.filtrosDefaultDocs.push('CND FGTS')
        } else if (coluna === 'trabalhista') {
          this.filtrosDefaultDocs.push('CND Trabalhista')
        } else if (coluna === 'estadual') {
          this.filtrosDefaultDocs.push('CND Estadual')
        } else if (coluna === 'municipal') {
          this.filtrosDefaultDocs.push('CND Municipal')
        }
        if (this.filtrosDefaultDocs.length === 5) {
          this.filtrosDefaultDocs.unshift('Todos')
        }
      })
    },
    aplicarFiltroCustom(filtroCustom) {
      this.filtroString = []
      this.filtroCustom = filtroCustom
      this.visibleColunas()
      this.$refs.portalDocumentosList.buscar()
    },
    mudarDocSelecionado(docs) {
      if (docs && docs.find(find => find === 'Todos')) {
        this.filtrosRapidosDocs = ['Todos']
        this.visibleColunas()
      } else {
        this.filtrosRapidosDocs = this.filtrosDefaultDocs
        this.visibleColunas()
      }
    },
    visibleColunas() {
      const filtroDocs = this.filtroString.length > 0
        ? this.filtroString
        : (this.filtroCustom?.filtrosDocs ?? []).filter(doc => this.filtrosDefaultDocs.includes(doc))
      this.visualizacao.colunas.forEach(coluna => {
        const isStatusColuna = this.arrayColunas.includes(coluna.field.toLowerCase())
        if (filtroDocs.length > 0 && !filtroDocs.includes('Todos')) {
          // Docs específicos: mostrar apenas colunas que batem
          const matches = filtroDocs.some(s => s.replace('/', '').replace(' ', '').replace('ç', 'c').replace('ã', 'a')
            .toLowerCase()
            .includes(coluna.field.toLowerCase()))
          // eslint-disable-next-line no-param-reassign
          if (isStatusColuna) coluna.visible = matches
        } else if (filtroDocs.includes('Todos')) {
          // 'Todos' selecionado: mostrar todas as colunas
          this.filtroString = ['Todos']
          // eslint-disable-next-line no-param-reassign
          coluna.visible = true
        } else if (isStatusColuna) {
          // Filtro vazio: ocultar colunas de status
          // eslint-disable-next-line no-param-reassign
          coluna.visible = false
        }
      })
      // Ajustar largura CNPJ/CPF conforme número de colunas visíveis
      const cnpjColuna = this.visualizacao.colunas.find(c => c.field === 'cadastroFederal')
      if (cnpjColuna) {
        const expandido = filtroDocs.includes('Todos') || filtroDocs.length >= 3
        // eslint-disable-next-line no-param-reassign
        cnpjColuna.tdClass = expandido ? 'col-tamanho-cnpj col-valores' : 'tamanho-col-cadastroFederal-portalDocumentos col-valores'
      }
    },
    resolverFiltroParaEnviar() {
      if (this.filtroString.length === 0 || this.filtroString.includes('Todos')) {
        return this.filtrosDefaultDocs.filter(f => f !== 'Todos')
      }
      return this.filtroString
    },
    carregar(pagina, tamanhoPagina, filtro) {
      this.filtroAtual = filtro
      return api.getPaginado(pagina, tamanhoPagina, filtro, this.resolverFiltroParaEnviar(), this.filtroCustom?.id ?? 0)
    },
    allPaged(filtro) {
      return api.getTodasLinhas(filtro, this.resolverFiltroParaEnviar(), this.filtroCustom?.id ?? '')
    },
    getColorTag(situacao) {
      if (situacao === 'EmAndamento') return 'light-primary'
      if (situacao === 'Ativa') return 'light-success'
      if (situacao === 'Retificada') return 'light-warning'
      if (situacao === 'Excluida') return 'light-danger'
      // Status CND (lowercase, de GetSituacaoGeral())
      if (situacao === 'regular') return 'light-success'
      if (situacao === 'irregular') return 'light-danger'
      if (situacao === 'emmanutencao') return 'light-warning'
      if (situacao === 'motivo') return 'light-dark'
      if (situacao === 'empregadornaocadastrado') return 'light-warning'
      // Status Situação Fiscal (capitalizados, de GetDescription())
      if (situacao === 'Regular') return 'light-success'
      if (situacao === 'Irregular') return 'light-danger'
      if (situacao === 'Instabilidade') return 'light-primary'
      if (situacao && situacao !== 'None') return 'light-warning'
      return 'light-dark'
    },
    getDescricao(situacao) {
      if (situacao === 'motivo') return 'Motivo'
      if (situacao === 'regular') return 'Regular'
      if (situacao === 'empregadornaocadastrado') return 'Empregador<br/>não cadastrado'
      if (situacao === 'emmanutencao') return 'Em manutenção'
      if (situacao === 'irregular') return 'Irregular'
      // SituacaoFiscal: retornar a descrição como está (ex: "Sem procuração", "Procuração vencida", etc.)
      if (situacao && situacao !== 'None') return situacao
      return '-'
    },
    baixaEmLoteGeral() {
      let empresas = this.$refs.portalDocumentosList.linhaSelecionada

      if (empresas === undefined || empresas.length === 0) {
        empresas = this.$refs.portalDocumentosList.gridInfo.dados.map(x => x.id)
      }

      api.baixaEmLote('Portal Documentos', {
        Agrupamento: this.tipoDownload,
        Docs: this.resolverFiltroParaEnviar(),
        Empresas: empresas,
        Filtro: this.filtroAtual,
        idFiltroCustom: this.filtroCustom?.id ?? 0,
        ValidarFiltroCustom: this.filtroCustom !== null || (this.$refs.portalDocumentosList.linhaSelecionada !== undefined && this.$refs.portalDocumentosList.linhaSelecionada.length > 0),
      }) // [16, 2]
      this.tipoDownload = null
    },
    /**
     * Envia e-mails em lote para as empresas selecionadas ou todas da grid.
     * @param {string} tipoDestinatario - Tipo de destinatário: 'principal', 'adicional' ou 'ambos'
     */
    enviarEmailLoteGeral(tipoDestinatario) {
      if (!this.filtroCustom && this.filtroString.length === 0) {
        this.$erro('Insira ao menos um Documento')
      } else {
        let empresas = this.$refs.portalDocumentosList.enviarServidor.linhasSelecionadas

        if (!empresas) {
          empresas = this.$refs.portalDocumentosList.gridInfo.dados
        }
        const empresaEmail = empresas.map(empresa => ({ empresaId: empresa.id, emailsCC: null, email: empresa.email ? empresa.email : null }))

        api.enviarEmLote('Portal Documentos', {
          docs: this.resolverFiltroParaEnviar(),
          empresas: this.$refs.portalDocumentosList.linhaSelecionada,
          empresasEmail: [...empresaEmail],
          tipoDestinatario,
          idFiltroCustom: this.filtroCustom?.id ?? 0,
        }).then(() => {
        }).catch(err => {
          this.$erro('Erro ao enviar os e-mails')
          throw err
        })
      }
    },
    enviarEmailLinha(linha, email) {
      if (!this.filtroCustom && this.filtroString.length === 0) {
        this.$erro('Insira ao menos um Documento')
      } else {
        this.isLoading = true

        const empresaEmail = {
          empresaId: linha.id,
          emailAdicionalEmpresa: email.emailsCc,
          email: email.emailsPara,
          mensagensAdicional: email.mensagensAdicional,
          definirEmailPadrao: email.definirEmailPadroes,
        }

        api.enviarEmLote('Portal Documentos', {
          docs: this.resolverFiltroParaEnviar(),
          empresasEmail: [empresaEmail],
          idFiltroCustom: this.filtroCustom?.id ?? 0,
        }).then(() => {
          this.isLoading = false
          this.$sucesso('E-mail enviado com sucesso')
        }).catch(err => {
          this.isLoading = false
          this.$erro('Erro ao enviar os e-mails', 'danger')
          throw err
        })
      }
    },
    baixaEmLoteLinha(empresaId) {
      api.baixaEmLote('Portal Documentos', { Docs: this.resolverFiltroParaEnviar(), Empresas: [empresaId], idFiltroCustom: this.filtroCustom?.id ?? 0 })
    },
    salvarEmail(empresa) {
      this.$refs.portalDocumentosList.gridInfo.dados.find(find => find.id === empresa.id).email = empresa.email
      api.salvarEmail(empresa.id, empresa.email)
        .then(() => {
          this.enviarEmailLinha(empresa, { emailsPara: [empresa.email], emailsCc: [] })
        })
    },
  },

}
</script>
